/**
 * 現在のwidthを取得する
 */
const getWidth = () => window.innerWidth

export { getWidth }
